<template>
  <div  :class="['q-card-to-do',{ 'embedded':isEmbedded }]">
    <div class="q-card-to-do-header" :style="{fontSize:todoHeaderFont}">
      สิ่งที่ต้องทำ <span class="mdi mdi-wunderlist"></span>
    </div>
    <div class="q-card-to-do-body">
      <span v-html="caseDescription" :style="{fontSize:askFont}"></span>
    </div>
    <div class="q-card-to-do-footer" :style="{fontSize:todoFooterFont}">
      <span :style="{fontSize:todoFooterFont}" class="mdi mdi-information-outline"></span>&nbsp;
      <span v-if="!isShowSurvey"
      :style="{fontSize:todoFooterFont}"
            @click="$emit('open-instruction')"
            class="underline">
        ดูขั้นตอนการรับบริการทั้งหมด
      </span>
      <span v-else
      :style="{fontSize:todoFooterFont}"
            @click="$emit('open-survey')"
            class="underline">
        ทำแบบประเมินความพึงพอใจระบบคิว
      </span>
    </div>
  </div>
</template>

<script>
const props = {
  caseDescription: {
    type: String,
    required: true
  },
  isShowSurvey: {
    type: Boolean,
    default: false
  }
}

export default {
  name: 'qCardToDo',
  props,
  mounted () {
    if (this.isEmbedded) {
      this.todoHeaderFont = '2.5rem'
      this.askFont = '3.5rem'
      this.todoFooterFont = '2rem'
    }
  },
  data () {
    return {
      todoHeaderFont: '',
      askFont: '',
      todoFooterFont: '',
      isEmbedded: process.env.VUE_APP_EMBEDDED === 'true'
    }
  }
}

</script>

<style lang="scss" scoped>
.q-card-to-do {
  margin: 0 1.375rem 1rem;
  padding: .25rem .5rem;
  border-radius: 16px;
  opacity: .8;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  &.embedded{
    border-radius: 40px;
  }
  .q-card-to-do-header {
    text-align: center;
    font-family: 'Mitr', sans-serif;
    font-size: 13px;
    color: #6e6e6e;
  }

  .q-card-to-do-body {
    text-align: center;
    font-family: 'Prajad', sans-serif;
    font-size: 1.125rem;
    font-weight: bold;
    color: #333333;
    padding: .75rem;
  }

  .q-card-to-do-footer {
    color: #b4b3b3;
    display: flex;
    align-items: center;
    justify-content: center;

    .underline {
      cursor: pointer;
      text-decoration: underline;
      font-family: 'Mitr', sans-serif;
      font-weight: 300;
      font-size: .75rem;
    }
  }
}
</style>
